import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import styled from 'styled-components';
const Container = styled.nav `
  width: 100%;
  height: var(--topLinksHeight);
  position: absolute;
  top: 0;
  padding: 0 36px;
  background: ${brand.blue.blue9};
`;
const ItemList = styled.ul `
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  width: 100%;
`;
const Item = styled.li `
  display: flex;
  align-items: center;

  &::after {
    display: inline-block;
    border-left: 1px solid ${brand.white};
    height: 16px;
    margin: 0 32px;
  }

  &:not(:last-child)::after {
    content: '';
  }
`;
const Link = styled.a `
  display: inline-block;
  color: ${brand.white};
  ${fonts.helvetica.bold};
  font-size: 18px;
  line-height: 28px;
  font-weight: 400;
  text-decoration: none;
  transition: color ease 0.15s;

  &:focus {
    outline: auto;
  }

  &:hover {
    color: ${brand.yellow.base};
  }
`;
const TopLinksStyles = {
    Container,
    Item,
    ItemList,
    Link,
};
export default TopLinksStyles;
